<template>
    <footer class="footer">
        <div class="copyright">
            © {{ year }} eCDC Tracker app version <span @click="$router.push({ name: 'changelogs' });">{{ version[0].value }}</span>
        </div>
    </footer>
</template>

<script>
import { version } from '../helpers/variables'
import { getVersionNumber } from '../api'
 
export default {
    data() {
        return {
            year: "",
            version: version
        }
    },
    mounted() {
        
        const date = new Date();
        this.year = date.getFullYear();
        this.getAppVersionNumber("app_version");
    },
    methods: {
        async getAppVersionNumber(typeName) {

            try {
                const result = await getVersionNumber({"type":typeName});
                this.version =  result.data.data;
            }
            catch(err) {
                return false;
            }
        }
    }
}
</script>

<style scoped>
.footer {
    flex-shrink: 0;
    text-align: center;
    margin-top: 50px;
}

.footer .copyright {
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>